<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Ghostly Tales Of The Adirondacks</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span> &amp; M<span class="small">AP</span> K<span class="small">EY</span></p>
<table>
<colgroup>
<col width="70px"/>
<col width="320px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Chapter 1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">The Many Ghosts of the Sagamore Resort</span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Chapter 2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Hauntings at the Brightside Training Center</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Chapter 3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">The Stagecoach Inn, Lake Placid</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Chapter 4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Séance at the Woodgate Free Library</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Chapter 5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Van Auken’s Inne</span></td></tr>
<tr><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Chapter 6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Flowers for the Dead at Fort William Henry</span></td></tr>
<tr><td><span href="#/Chapter07#C7" title="Link target outside of Sample">Chapter 7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">The Toboggan Inn</span></td></tr>
<tr><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Chapter 8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Rhinelander Estate in Speculator, Lake Pleasant</span></td></tr>
<tr><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Chapter 9.</span></td><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Spirits of the Hotel Saranac</span></td></tr>
<tr><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Chapter 10.</span></td><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Bigfoot, Ohio, New York</span></td></tr>
<tr><td colspan="2"><span href="#/Conclusion#Con" title="Link target outside of Sample">Conclusion</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3c50768a